@if (branding()) {
  {{ branding().name }}
} @else {
  Zeffi
}
